import { RunCurse, UnlockState } from '../types';

const CURSES: RunCurse[] = [
  {
    id: 'blood_tax',
    name: 'Blood Tax',
    text: 'On Draw: Lose 2 HP.',
    pack: 1,
    onDraw: { hpLoss: 2 },
  },
  {
    id: 'heavy_hand',
    name: 'Heavy Hand',
    text: 'On Draw: Draw -1 next turn.',
    pack: 1,
    onDraw: { drawPenaltyNextTurn: 1 },
  },
  {
    id: 'backfire',
    name: 'Backfire',
    text: 'On Play (ATK): Lose 4 HP.',
    pack: 1,
    onPlay: { slot: 'attack', hpLoss: 4 },
  },
  {
    id: 'cracked_guard',
    name: 'Cracked Guard',
    text: 'On Play (DEF): Lose 3 HP.',
    pack: 1,
    onPlay: { slot: 'defense', hpLoss: 3 },
  },
  {
    id: 'static_noise',
    name: 'Static Noise',
    text: 'On Play (ABL): Draw -1 next turn.',
    pack: 1,
    onPlay: { slot: 'ability', drawPenaltyNextTurn: 1 },
  },
  {
    id: 'fumble_runes',
    name: 'Fumble Runes',
    text: 'On Play (ATK): Draw -1 next turn.',
    pack: 1,
    onPlay: { slot: 'attack', drawPenaltyNextTurn: 1 },
  },
  {
    id: 'ashen_weight',
    name: 'Ashen Weight',
    text: 'On Draw: Lose 1 HP and Draw -1 next turn.',
    pack: 1,
    onDraw: { hpLoss: 1, drawPenaltyNextTurn: 1 },
  },
  {
    id: 'bleeding_edge',
    name: 'Bleeding Edge',
    text: 'On Draw: Lose 3 HP.',
    pack: 2,
    onDraw: { hpLoss: 3 },
  },
  {
    id: 'lead_boots',
    name: 'Lead Boots',
    text: 'On Draw: Draw -2 next turn.',
    pack: 2,
    onDraw: { drawPenaltyNextTurn: 2 },
  },
  {
    id: 'fracture',
    name: 'Fracture',
    text: 'On Play (DEF): Lose 5 HP.',
    pack: 2,
    onPlay: { slot: 'defense', hpLoss: 5 },
  },
  {
    id: 'void_spark',
    name: 'Void Spark',
    text: 'On Play (ABL): Lose 2 HP and Draw -1 next turn.',
    pack: 2,
    onPlay: { slot: 'ability', hpLoss: 2, drawPenaltyNextTurn: 1 },
  },
  {
    id: 'soul_leak',
    name: 'Soul Leak',
    text: 'On Draw: Lose 2 HP and Draw -1 next turn.',
    pack: 2,
    onDraw: { hpLoss: 2, drawPenaltyNextTurn: 1 },
  },
  {
    id: 'black_ice',
    name: 'Black Ice',
    text: 'On Play (ATK): Lose 2 HP and Draw -1 next turn.',
    pack: 2,
    onPlay: { slot: 'attack', hpLoss: 2, drawPenaltyNextTurn: 1 },
  },
  {
    id: 'null_brand',
    name: 'Null Brand',
    text: 'On Play (ABL): Lose 3 HP.',
    pack: 2,
    onPlay: { slot: 'ability', hpLoss: 3 },
  },
];

export function getCurseById(curseId: string): RunCurse | undefined {
  return CURSES.find(curse => curse.id === curseId);
}

export function getCursePool(unlockSnapshot: UnlockState): RunCurse[] {
  return CURSES.filter(curse => curse.pack <= unlockSnapshot.cursePack);
}

export function getCursePack(unlockSnapshot: UnlockState, pack: number): RunCurse[] {
  return CURSES.filter(curse => curse.pack <= unlockSnapshot.cursePack && curse.pack === pack);
}

export function listAllCurses(): RunCurse[] {
  return [...CURSES];
}

export function getCurseText(curseId: string): string {
  const curse = getCurseById(curseId);
  return curse ? `${curse.name}: ${curse.text}` : 'Unknown curse';
}
